import type { PartGroupKind } from "../../api/manufacturing";

/** Any translate function: the hook's `t`, or a config page's plain one. */
type Translate = (key: string, fallback: string) => string;

export function partGroupKindLabel(kind: PartGroupKind, t: Translate): string {
  switch (kind) {
    case "MATERIAL":
      return t("part-group-kind.material", "Material");
    case "FINISHED":
      return t("part-group-kind.finished", "Finished product");
    case "GENERAL":
      return t("part-group-kind.general", "General");
  }
}
